var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%"}},[_c('DesktopHeader'),_c('v-container',[_c('v-row',{staticClass:"ma-0",attrs:{"no-gutters":""}},[_c('CashbookTemplateGrid',{on:{"EditItem":_vm.onEditItem,"ViewItem":_vm.onViewItem,"DeleteItem":_vm.onDeleteItem,"AddItem":_vm.onAddItem}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }